import UITable from 'UIComponents/table/UITable';
import Small from 'UIComponents/elements/Small';
import UISortTH from 'UIComponents/table/UISortTH';
import { useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import ApprovalEditPanelTableCheckboxRow from './ApprovalEditPanelTableCheckboxRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalEditPanelTable = props => {
  const {
    approvedApproverIds,
    approversAll,
    changeCheckbox,
    selectedApproverIdsMutable
  } = props;
  const {
    data
  } = useApprovalContext();
  const [sortDirection, setSortDirection] = useState('ascending');
  const approversAllSortable = useMemo(() => {
    if (sortDirection === 'ascending') {
      return [...approversAll].sort((a, b) => a.firstName.toLocaleLowerCase() < b.firstName.toLocaleLowerCase() ? -1 : 1);
    } else {
      return [...approversAll].sort((a, b) => b.firstName.toLocaleLowerCase() < a.firstName.toLocaleLowerCase() ? -1 : 1);
    }
  }, [approversAll, sortDirection]);
  const sortTable = event => {
    setSortDirection(event.target.value);
  };
  if (!data) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UITable, {
    children: [/*#__PURE__*/_jsxs("colgroup", {
      children: [/*#__PURE__*/_jsx("col", {}), /*#__PURE__*/_jsx("col", {
        width: 150
      })]
    }), /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx(UISortTH, {
          className: "align-center justify-between",
          onSortChange: sortTable,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.users"
          })
        }), /*#__PURE__*/_jsx("th", {
          className: "text-right",
          children: /*#__PURE__*/_jsx(Small, {
            use: "help",
            style: {
              textTransform: 'none',
              fontWeight: 'normal'
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.selected",
              options: {
                count: selectedApproverIdsMutable.length
              }
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: approversAllSortable.map(approver => /*#__PURE__*/_jsx(ApprovalEditPanelTableCheckboxRow, {
        approver: approver,
        changeCheckbox: changeCheckbox,
        checkboxIsApproved: approvedApproverIds.includes(approver.ownerId),
        checkboxIsDisabled: approvedApproverIds.includes(approver.ownerId) || approver.ownerId === data.requester.ownerId,
        checkboxIsRequester: approver.ownerId === data.requester.ownerId,
        checkboxIsSelected: selectedApproverIdsMutable.includes(approver.ownerId)
      }, approver.ownerId))
    })]
  });
};
export default ApprovalEditPanelTable;